module.exports = __webpack_public_path__ + "static/img/tabela.cfd98af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-zero/tabela.png
// module id = zWmN
// module chunks = 0